import React from 'react';
import { MIDDLE_STYLE } from '@constants/responsive';
import { GLOBAL_THEME_COLOR, STRIPE_BOX_SHADOW } from '@constants/theme';
import { useParams } from 'react-router';
import { ReservationFormContainer } from '@components/index';
import { useBreakpoint } from '@core/hooks';

const BookingAppScreen: React.FC<any> = () => {
  const { locationId } = useParams<{ locationId: string }>();
  const { isMobile } = useBreakpoint();

  return (
    <div
      style={{
        ...MIDDLE_STYLE,
        flexDirection: 'column',
        backgroundColor: GLOBAL_THEME_COLOR.$secondary_color,
        backgroundImage: `radial-gradient(${GLOBAL_THEME_COLOR.$dark_secondary_color} 8%, transparent 0)`,
        backgroundSize: '20px 20px',
        minHeight: '100vh',
      }}>
      <div
        style={{
          backgroundColor: 'white',
          padding: '20px 30px',
          borderRadius: 10,
          maxWidth: 600,
          height: isMobile ? '100vh' : 'auto',
          paddingBottom: isMobile ? 50 : 20,
          overflowY: 'scroll',
          width: '100%',
          border: `2px solid ${GLOBAL_THEME_COLOR.$border_color}`,
          boxShadow: STRIPE_BOX_SHADOW,
        }}>
        <ReservationFormContainer propsLocationId={locationId} />
      </div>
    </div>
  );
};

export default BookingAppScreen;
